module.exports = __webpack_public_path__ + "img/sandy-and-lou-people.e117bbf5.jpg";